<template>
    <tr>
        <td>{{ itemnumber }}</td>
        <td>
            <router-link :to="productDetailsLink" class="cart-table__product-name">{{ itemdesc }}</router-link>
        </td>
        <!-- <td class="center-elements-text">{{ quantity }}</td> -->
        <td class="text-right">{{ quantity }}</td>
        <td class="text-right">{{ toUSD(price) }}</td>
        <td class="text-right">{{ toUSD(core) }}</td>
        <td class="text-right">{{ toUSD(total) }}</td>
    </tr>

</template>

<script>
import Price from '../../../mixins/price.js';

export default {
    mixins: [Price],
    props: {
        itemnumber: {
            type: String,
            required: true
        },
        itemdesc: {
            type: String
        },
        mfgcode: {
            type: String
        },
        quantity: {
            type: Number,
            default: 0
        },
        price: {
            type: Number,
            default: 0
        },
        core: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        },
    },
    computed: {
        productDetailsLink() {
            return '/part/' + this.mfgcode + '/' + this.itemnumber;
        },
    }
}
</script>